import React from 'react';

import '@/styles/globals.v2.css';

import Image from 'next/image';

import crossIcon from '@/assets/icons/interstitial-modal-cross-icon.svg';
import cn from '@/helpers/utils/classNames';

interface InterstitialModalCloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconClassName?: string;
}

const InterstitialModalCloseButton = ({ className, iconClassName, ...props }: InterstitialModalCloseButtonProps) => (
  <button
    {...props}
    // type="button"
    // scheme="text"
    // variant="filled"
    // btnSize="sm"
    // as="button"
    className={cn(
      'v2-absolute v2-right-4 v2-top-4 !v2-rounded-full !v2-bg-[#21242799] md:!v2-bg-transparent !v2-p-0 v2-w-6 v2-h-6 v2-outline-none v2-outline-0',
      className
    )}
  >
    <Image
      src={crossIcon}
      width={24}
      height={24}
      alt="close interstitial modal"
      className={cn('v2-invert md:v2-invert-0', iconClassName)}
    />
  </button>
);

export default InterstitialModalCloseButton;
